// export const createAction = (type, payload) => ({ type:type, payload:payload})
export const CreateAction = (type, payload) => ({ type, payload})

/**
 *  In JavaScript, when a property name in an object literal is the same as the variable name, you can use a shorthand by just writing the variable name
 */